import { useState } from 'react'
import type { UseQueryResult } from 'react-query'
import type { Developer } from '@yuno/types'
import { useGetCredentials } from '@yuno/dashboard-api-mfe'
import { useAccount } from '@yuno/dashboard-container-mfe'

export const useApiKeys = () => {
  const [showSnackbar, setShowSnackbar] = useState<boolean>(false)
  const account = useAccount()

  const {
    data,
    isLoading,
    isFetching,
  }: UseQueryResult<Developer.DeveloperCredentials, unknown> =
    useGetCredentials()

  const onCopied = () => {
    setShowSnackbar(true)
  }

  return {
    onCopied,
    data,
    isLoading: isLoading || isFetching,
    showSnackbar,
    accountId: account?.code,
    setShowSnackbar,
  }
}
